import React, { useCallback } from 'react';

import { expValEquals } from '@confluence/feature-experiments';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import {
	HOME,
	SPACE_SETTINGS_SHAREABLE_LINKS,
} from '@confluence/named-routes/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ShareableLinkSpaceAdminConfigurationLoader } from '@confluence/access-links/entry-points/ShareableLinkSpaceAdminConfigurationLoader.ts';

export const ShareableLinkSpaceSettingsConfigurationRoute: {
	({ params: { spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(
		{ name, params: { spaceKey } }: RouteMatch,
		isNav4Enabled: any,
	): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
			};
			pageState: {
				routeName: string;
				spaceKey: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
		};
	};
} = ({ params: { spaceKey } }: RouteMatch): React.JSX.Element => {
	const { push } = useRouteActions();

	const handleBack = useCallback(
		() => push(SPACE_SETTINGS_SHAREABLE_LINKS.toUrl({ spaceKey })),
		[push, spaceKey],
	);

	if (!expValEquals('shareable_links_m0', 'isEnabled', true)) {
		return <Redirection name={HOME.name} />;
	}

	return <ShareableLinkSpaceAdminConfigurationLoader onBack={handleBack} spaceKey={spaceKey} />;
};

ShareableLinkSpaceSettingsConfigurationRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } }: RouteMatch,
	isNav4Enabled: any,
): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
		};
		pageState: {
			routeName: string;
			spaceKey: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'spaceSettingsAccessLinksConfigurationScreen',
			id: spaceKey,
		},
		pageState: {
			routeName: name,
			spaceKey,
		},
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
